import { IBaseResult, IExportListener } from 'app/helper/export/types';
import { root } from 'app/store/constants';
import { fetchHandler } from 'app/util/fetchHandler';
import { getRestHeadersPost } from 'app/rest/helpers/getRestHeadersHelper';
import { IApplicationState } from 'app/types/types';
import { IBoard } from 'app/store/model/board/types';
import { getDateFormatted } from 'app/view/react_components/helpers/dateService';
import { getUserTimeFormat12 } from 'app/store/model/authUser/selectors/getUserTimeFormat12';

const EXPORT_START_URL = '/rest/spreadsheetExport/start/';
const EXPORT_ROWS_URL = '/rest/spreadsheetExport/continue';
const EXPORT_FINISH_URL = '/rest/spreadsheetExport/finish';

export type State = {
    [key: string]: any
}

type TParams = {
    [key: string]: any
}

export interface IResult {
    state: State;
    requestStatus: IBaseResult;
}

export class  SimpleSpreadsheetExportService{

    static startExport = (
        boardId: number,
        fileName: string,
        state: State,
        listener: IExportListener,
    ) => {
        let params: TParams = {}
        params.rand = Math.random();
        params.fileName = fileName;
        listener.onStart();
        const url = root.App.Util.getApiUrl(
            EXPORT_START_URL +boardId
            + '?'
            + new URLSearchParams(params).toString()
        );
        return fetchHandler<IResult>(url,
            {
                ...getRestHeadersPost(),
                body: JSON.stringify(state)
            })
            .then((result) => {
                if (!checkResponseError(result.requestStatus, listener.onError)){
                    return Promise.reject(result)
                }
                return result;
            })
    }

    static continueExport = (
        rows: Array<string[]>,
        state: State,
        listener: IExportListener,
    ) => {
        const url = root.App.Util.getApiUrl(EXPORT_ROWS_URL);
        return fetchHandler<IResult>(
            url,
            {
                ...getRestHeadersPost(),
                body: JSON.stringify({
                    state,
                    rows
                })
            }
        ).then(result => {
            if (!checkResponseError(result.requestStatus, listener.onError)){
                return Promise.reject(result)
            }
            return result;
        });
    }

    static finishExport = (
        state: State,
        listener: IExportListener,
    ) => {
        return fetchHandler<IResult>(
            root.App.Util.getApiUrl(EXPORT_FINISH_URL),
            {
                ...getRestHeadersPost(),
                body: JSON.stringify(state)
            }
        ).then(result => {
            if (!checkResponseError(result.requestStatus, listener.onError)){
                return Promise.reject(result)
            }
            listener.onProgress(100);
            listener.onSuccess();
            return result;
        })
    }

}

const checkResponseError = (
    result: IBaseResult,
    onError: (errorMessage: string) => void
): boolean => {
    if (!result.success) {
        if (onError) {
            onError(result.errorMessage)
        }
        return false;
    }
    return true;
}

export const getExportFileName = (
    state: IApplicationState,
    board: IBoard,
    fileNamePrefix: string = '',
) => {
    const date = getDateFormatted(Math.floor(new Date().getTime() / 1000), getUserTimeFormat12(state));
    const fileName = board.name + ' ' + fileNamePrefix + ' (' + date + ')';
    return fileName;
}
